import React from "react";
import styled from "styled-components";
import {
  getHeading6RegularTypography,
  getParagraph14RegularTypography,
} from "../../../Typography";
import Avatar from "../../Avatar";
import { useTranslation } from "react-i18next";
import { getParagraph16RegularTypography } from "../../../Typography/Paragraph16";
import { IBid } from "../../../commonTypes";
import { routes } from "../../../../routes";
import StaticLink from "../../StaticLink/StaticLink";

const Root = styled.div`
  width: 100%;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

const Details = styled.div`
  width: 100%;
  display: grid;
  column-gap: 16px;
`;

const BidDetails = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const AvatarContainer = styled.div`
  display: flex;
  align-items: center;
  padding-right: 16px;
`;

const BidEth = styled.h4`
  ${getHeading6RegularTypography};
  color: ${({ theme }) => theme.primaryColor};
  line-height: 23px;
`;

const BidLabel = styled.p`
  ${getParagraph16RegularTypography};
  color: ${({ theme }) => theme.primaryColor};
  opacity: 0.7;

  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    ${getParagraph14RegularTypography};
  }
`;

const BidFiat = styled.h4`
  ${getHeading6RegularTypography};
  color: ${({ theme }) => theme.primaryColor};
  line-height: 23px;
`;

type Props = {
  bid?: IBid;
  price: string;
  priceUsd: string;
  currency: string;
};

const AuctionBidPanel = ({ bid, price, priceUsd, currency }: Props) => {
  const { t } = useTranslation();
  const user = bid?.user;

  return (
    <Root>
      <Container>
        {user && (
          <AvatarContainer>
            <StaticLink href={routes.user.url(user.uri)}>
              <Avatar user={user} />
            </StaticLink>
          </AvatarContainer>
        )}
        <Details>
          <BidLabel>
            {user ? t("auction-highest-bid") : t("auction-starting-label")}
          </BidLabel>
          <BidDetails>
            <BidEth>
              {price} {currency}
            </BidEth>
            <BidFiat>${priceUsd}</BidFiat>
          </BidDetails>
        </Details>
      </Container>
    </Root>
  );
};

export default AuctionBidPanel;
